import { render, staticRenderFns } from "./OrderRow.vue?vue&type=template&id=446fda42&scoped=true&"
import script from "./OrderRow.vue?vue&type=script&lang=js&"
export * from "./OrderRow.vue?vue&type=script&lang=js&"
import style0 from "./OrderRow.vue?vue&type=style&index=0&id=446fda42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446fda42",
  null
  
)

export default component.exports